/**
 * Shared device selector dropdown.
 *
 * Props:
 *   devices      - Array of device objects with mac_address and optional name
 *   value        - Currently selected mac_address
 *   onChange     - Callback (mac_address: string) => void
 *   placeholder  - Placeholder option text (default "Select a device")
 *   showReadings - If true, shows reading count in the option label
 *   className    - Additional CSS classes for the outer wrapper
 *   disabled     - Lock the dropdown (e.g. while an experiment run is active)
 */
const DeviceSelector = ({
  devices = [],
  id,
  value,
  onChange,
  placeholder = "Select a device",
  showReadings = false,
  className = "",
  disabled = false,
}) => (
  <div className={`relative ${className}`}>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="w-full appearance-none bg-surface-container-low border-0 border-b-2 border-outline-variant focus:border-primary focus:ring-0 px-0 py-2 pr-6 text-sm font-medium text-on-surface transition-colors cursor-pointer truncate disabled:cursor-not-allowed disabled:opacity-60"
    >
      {placeholder && (
        <option value="" className="text-on-surface-variant">
          {placeholder}
        </option>
      )}
      {devices.map((device) => (
        <option key={device.mac_address} value={device.mac_address}>
          {device.name || device.mac_address}
          {showReadings && device.reading_count != null
            ? ` (${device.reading_count} readings)`
            : ""}
        </option>
      ))}
    </select>
    {/* Custom chevron */}
    <span className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 text-on-surface-variant text-xs">
      ▾
    </span>
  </div>
);

export default DeviceSelector;
